/* esm.sh - @use-gesture/core@10.3.1/utils */
import{r as f}from"@use-gesture/core/dist/maths-0ab39ae9.esm";export{f as rubberbandIfOutOfBounds};
//# sourceMappingURL=utils.mjs.map